import "./customers.css"
import { useState, useCallback, useEffect } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

// IMPORTA DOIS LOGOS DIFERENTES
import logoCustomersPT from "../../imagens/logos/logoClientesFinais.png"
import logoCustomersEN from "../../imagens/logos/logoClientesFinaisEn.png"

function Customers({ listCustomer }) {

    const { t, i18n } = useTranslation();

    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)

    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const prevSlide = useCallback(() => {
        slideNumber === 0 ?
            setSlideNumber(listCustomer.length - 1) :
            setSlideNumber(slideNumber - 1)
    }, [slideNumber, listCustomer.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listCustomer.length ?
            setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)
    }, [slideNumber, listCustomer.length])

    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break
                case 'ArrowRight':
                    nextSlide()
                    break
                default:
                    break
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);

    // ESCOLHE O LOGO PELO IDIOMA ATUAL
    const selectedLogo = i18n.language === "en" ? logoCustomersEN : logoCustomersPT;

    return (
        <div>
            {
                openModal &&
                <div className='customerSliderWrap'>
                    <FontAwesomeIcon icon={faCircleChevronLeft} className="customerBtnPrev" onClick={prevSlide} />
                    <FontAwesomeIcon icon={faCircleChevronRight} className="customerBtnNext" onClick={nextSlide} />
                    <FontAwesomeIcon icon={faCircleXmark} className="customerBtnClose" onClick={handleCloseModal} />
                    <img className='customerFullScreenImage' src={listCustomer[slideNumber].img} alt='customerImg' />
                </div>
            }

            {/* LOGO CUSTOMERS */}
            <div>
                <img className='img-custom-size img-fluid ms-2' src={selectedLogo} alt='logoCustomer' />
            </div>

            {/* GALERIA */}
            <div className="customerGalleryWrap mx-2">
                {
                    listCustomer && listCustomer.map((image, index) => (
                        <div
                            className="customerSingle border"
                            key={index}
                            onClick={() => handleOpenModal(index)}
                        >
                            <img src={image.img} alt="CustomersImg" />
                        </div>
                    ))
                }
            </div>

            {/* BOTÃO VOLTAR AO INÍCIO */}
            <div className="text-center text-nowrap my-4">
                <Link to="/">
                    <button className="buttonCapabilities">{t("customers.backToHome")}</button>
                </Link>
            </div>
        </div>
    )
}

export default Customers
